'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENDPOINT_URL = '/shopping/v3/orders/merchandise';

var quantityUpgradesApi = {
  post: function post(data) {
    return _apiClient2.default.post(ENDPOINT_URL, { data: data }).then(function (purchaseOrder) {
      return purchaseOrder.id;
    });
  }
};

exports.default = quantityUpgradesApi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/quantityUpgradesApi.js
// module id = 586
// module chunks = 3 4 5